import { styled, Typography } from "@mui/material";

const DialogTypographyTitle = styled(Typography)(() => ({
    paddingBottom: "0.125rem",
    paddingTop: "0.25rem",
    fontWeight: "500",
    fontSize: "0.95rem",
}))

export default DialogTypographyTitle;